import React, { useEffect, useState } from 'react';
import Header from '../../Layout/Header';
import Sidebar from '../../Layout/Sidebar';
import HeroBanner from '../../components/HeroBanner';
import AccordionItemChecklist from '../../components/AccordionItemChecklist';
import { fetchChecklists } from '../../services/checklistService';
import { getChecklistStatus } from '../../utils/checklistUtils';
import { FooterMobile } from '../../Layout/FooterMobile';
import { useChecklist } from '../../context/ChecklistContext';
import olsBanner from '../../assets/images/siteImg/checklistImg/BannerImage_OLS.png';
import schoolFAQ from '../../assets/images/siteImg/checklistImg/Image_FAQ.png';
import navigateOS from '../../assets/images/siteImg/checklistImg/Image_Navigate.png';
import sampleLesson from '../../assets/images/siteImg/checklistImg/Image_SampleLessons.png';
import { useOktaAuth } from '@okta/okta-react';
import config from '../../config';

const MainChecklistOnlineSchool: React.FC = () => {
    type ChecklistItem ={
        title: string;
        description: string;
        imageUrl: string;
        linkUrl: string;
        status: string;
    }

    const { HOME, MAIN_CHECKLIST_DOMAIN, SCHOOL_PREP_CHECKLIST, SCHOOL_START_FAQ, NAVIGATE_OS, SAMPLE_LESSONS } = config.app.routes;
    const { checklistData, checklistTopicStatus } = useChecklist();
        
    // Filter checklist items for the "LEARNING_COACH_LIFE" category
    const getChecklistCategoryName = checklistData.filter(
        item => item.checklistCategoryName === "ONLINE_SCHOOL"
    );
    // Extract unique category name capitalization format
    const categoryName = getChecklistCategoryName.length > 0
    ? getChecklistCategoryName[0].checklistCategoryName
        .toLowerCase()
        .replace(/_/g, " ")
        .split(" ")
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "Online School";

    // Prepare data from both frontend & API to each checklist item
    const checklistItems_arr = [
        {
            description: "Questions? Start here to get more details on the main things online school families need to know!",
            imageUrl: schoolFAQ
        },
        {
            description: "Learn how to get around in the Online School (OLS) with this beginner-friendly tutorial.",
            imageUrl: navigateOS
        },
        {
            description: 'While you’re still waiting for your courses to begin, get a sense of what to expect with these examples.',
            imageUrl: sampleLesson
        }
    ];
    const checklistWithStatus = getChecklistCategoryName.map((item, index) => ({
        ...checklistItems_arr[index],
        title: item.description,
        checklistId: item.checklistId,
        status: getChecklistStatus(item.checklistId, checklistTopicStatus),
        linkUrl: `${MAIN_CHECKLIST_DOMAIN}/${item.checklistName.toLowerCase().replace(/_/g, '-')}`,
    }));
    const breadcrumbItems = [
        { label: "Home", path: HOME },
        { label: "School Prep Checklist", path: SCHOOL_PREP_CHECKLIST },
        { label: categoryName }, 
    ];

    const checklistItems = [
        {
            title: 'School Start FAQs',
            description: 'Questions? Start here to get more details on the main things online school families need to know!',
            imageUrl: {schoolFAQ},
            linkUrl: `${SCHOOL_START_FAQ}`,
            status: 'Begin Topic',
            },
        {
            title: 'Navigating the Online School ',
            description: 'Learn how to get around in the Online School (OLS) with this beginner-friendly tutorial.',
            imageUrl: {navigateOS},
            linkUrl: `${NAVIGATE_OS}`,
            status: 'Completed',
        },
        {
            title: 'Sample Lessons',
            description: 'While you’re still waiting for your courses to begin, get a sense of what to expect with these examples.',
            imageUrl: {sampleLesson},
            linkUrl: `${SAMPLE_LESSONS}`,
            status: 'Begin Topic',
        },
    ];

    return (
        <div className="home-layout">
            <div className="sidebar-wrapper">
            <Sidebar />
            </div>
            <div className="body-wrapper-content">
            <div className="row">
                <div className="col-12">
                <Header />
                <main id="main" role="main">
                    <div className="main-content" id="online-school-category">
                        <div className="row">
                            <div className="col-12">
                                <nav aria-label="breadcrumb" className="d-none d-sm-block">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <a href={HOME}>Home</a>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <a href={SCHOOL_PREP_CHECKLIST}>
                                                School Prep Checklist
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <span>Online School</span>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>

                        {/* Hero Section */}
                        <HeroBanner
                            title="Online School"
                            subtitle="Instead of heading to a school building, your student will spend time learning in the Online School, known as the OLS. Here’s what you need to know to get started."
                            imageUrl={olsBanner}
                            altText="Online School"
                            customClass="bg-color-blue-t1-checklist common-banner-bg-white"
                        />

                        {/* Checklist Section */}
                        <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-1 wp-block-columns-is-layout-flex">
                            <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: '66.66%' }}>
                                <div className="wp-block-k12-section container-fluid bg-transparent">
                                    <div className="row">
                                        <div className="col-12 g-0">
                                            <div className="wp-block-k12-checklist-grid container-fluid">
                                                <div className="row">
                                                    <div className="col-12">
                                                    <ul>
                                                        {checklistWithStatus.map((item, index) => (
                                                            <AccordionItemChecklist
                                                            key={index}
                                                            title={item.title}
                                                            description={item.description}
                                                            imageUrl={item.imageUrl}
                                                            linkUrl={item.linkUrl}
                                                            status={item.status}
                                                            />
                                                        ))}
                                                    </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: '33.33%' }}>
                            </div>
                        </div>

                
                    </div>
                </main>
                </div>
            </div>
            </div>
            <FooterMobile />
        </div>
    );
};
export default MainChecklistOnlineSchool;